
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetojyotilingadarshanpackage() {



    const cardData =
    {
        keyword: 'Pune to Jyotirlinga Darshan Package',
        heading: 'Meghana Cab : Pune to Jyotirlinga Darshan Package',
        headingDescription: 'Meghana Cab offers Pune to Jyotirlinga Darshan Cab Packages, providing a spiritual and comfortable travel experience to sacred Jyotirlinga temples across Maharashtra and beyond. Whether you’re planning a one-day visit to Bhimashankar or a multi-day pilgrimage covering Trimbakeshwar, Grishneshwar, and Aundha Nagnath, our reliable cab service ensures safe, punctual, and devotional journeys. Choose from well-maintained sedans, SUVs, and tempo travellers equipped for long-distance comfort and convenience. With experienced drivers familiar with temple routes, flexible itineraries, and transparent pricing, Meghana Cab makes your Jyotirlinga Yatra peaceful and worry-free. Book your Pune to Jyotirlinga Darshan Package with Meghana Cab and embark on a soulful journey with comfort, devotion, and reliability.',


        top: 'Top Places to Visit in Jyotirlinga with Meghana Cab',

"topPlaces": [
  {
    "title": "Somnath Jyotirlinga – Gujarat",
    "description": "Somnath, meaning ‘Lord of the Moon,’ is the first of the twelve Jyotirlingas, located on the Arabian Sea coast in Prabhas Patan near Veraval, Gujarat. It has been destroyed and rebuilt several times, symbolizing resilience and devotion. The temple’s Chalukyan architecture and spiritual vibrations draw millions of pilgrims each year. The evening aarti and light-and-sound show narrate its divine history. Legends say Lord Shiva manifested here to free the Moon God, Chandra, from a curse. Nearby attractions include Triveni Sangam, Bhalka Tirth, and the Prabhas Museum."
  },
  {
    "title": "Mallikarjuna Jyotirlinga – Andhra Pradesh",
    "description": "Situated on the Shri Shaila mountain beside the Krishna River in Andhra Pradesh, Mallikarjuna Jyotirlinga represents Lord Shiva and Goddess Parvati’s eternal bond. It is one of the rare shrines where both are worshipped together. The temple’s Dravidian architecture and sacred surroundings attract devotees from across South India. Mythologically, it marks the place where Lord Shiva came to console his son Kartikeya. Visitors can explore the nearby Srisailam Dam, Akkamahadevi Caves, and Pathala Ganga, all enveloped in spiritual and natural beauty."
  },
  {
    "title": "Mahakaleshwar Jyotirlinga – Madhya Pradesh",
    "description": "Located in Ujjain on the banks of the holy Shipra River, Mahakaleshwar is the only Jyotirlinga facing south, symbolizing time and eternity. The temple is famous for its early-morning Bhasma Aarti, performed with sacred ash. Believers come here to seek freedom from fear and death. The underground sanctum creates a mystical aura during rituals. Ujjain is also renowned for the Kumbh Mela and temples like Kal Bhairav and Harsiddhi Mata. The combination of divine energy and historical grandeur makes Mahakaleshwar a must-visit on any Jyotirlinga Yatra."
  },
  {
    "title": "Omkareshwar Jyotirlinga – Madhya Pradesh",
    "description": "Omkareshwar lies on the sacred Narmada River, shaped like the auspicious Hindu symbol ‘Om’. The temple represents Lord Shiva’s manifestation as the ‘Lord of Omkara’. It is believed that a single visit here grants spiritual fulfillment and moksha. Pilgrims often cross the suspension bridge to reach the island temple surrounded by serene waters. The nearby Mamleshwar Temple is also revered as part of the same energy. With its scenic backdrop of hills and ghats, Omkareshwar combines natural tranquility with spiritual awakening."
  },
  {
    "title": "Kedarnath Jyotirlinga – Uttarakhand",
    "description": "Nestled amid the snow-capped Himalayas near the Mandakini River, Kedarnath Jyotirlinga is one of India’s holiest pilgrimage destinations. Accessible only during summer, the temple stands at 3,583 meters and is believed to be built by the Pandavas to atone for their sins. Its stone structure against the mighty Kedarnath peak is breathtaking. Helicopter services and trekking routes from Gaurikund make the journey memorable. The temple’s serenity, divine chants, and snow-clad backdrop create an experience that connects devotees directly with Shiva’s cosmic presence."
  },
  {
    "title": "Bhimashankar Jyotirlinga – Maharashtra",
    "description": "Located in the Sahyadri hills near Pune, Bhimashankar Jyotirlinga is surrounded by dense forests and misty valleys. It marks the spot where Lord Shiva vanquished the demon Tripurasura. The temple’s Nagara-style architecture and tranquil surroundings attract both pilgrims and nature lovers. It also serves as the origin of the Bhima River. The Bhimashankar Wildlife Sanctuary nearby is home to the rare giant squirrel. Visitors enjoy monsoon treks, temple rituals, and scenic viewpoints, making it a perfect blend of spirituality and adventure."
  },
  {
    "title": "Kashi Vishwanath Jyotirlinga – Uttar Pradesh",
    "description": "Located on the banks of the Ganga in Varanasi, Kashi Vishwanath is among the most revered temples in India. It is believed that a visit here grants liberation from the cycle of life and death. The golden spire of the temple gleams majestically against the holy city’s skyline. Daily aartis, Ganga ghats, and the vibrant energy of Varanasi make it a transformative experience. The newly developed Kashi Corridor enhances the spiritual journey. Nearby attractions include Dashashwamedh Ghat, Manikarnika Ghat, and Sarnath."
  },
  {
    "title": "Trimbakeshwar Jyotirlinga – Maharashtra",
    "description": "Situated near Nashik at the foothills of the Brahmagiri Mountain, Trimbakeshwar is the source of the sacred Godavari River. Uniquely, its lingam embodies the holy trinity of Brahma, Vishnu, and Mahesh. The black stone temple built by Peshwa Balaji Bajirao features intricate architecture and a sacred water tank. Devotees visit to perform Narayan Nagbali rituals and seek ancestral peace. The spiritual aura, combined with Nashik’s vineyards and Panchavati sites, makes it a powerful pilgrimage and cultural destination."
  },
  {
    "title": "Nageshwar Jyotirlinga – Gujarat",
    "description": "Located near Dwarka on the Saurashtra coast, Nageshwar is one of the most powerful Jyotirlingas, symbolizing protection from evil and poison. The massive Shiva statue and temple tower rise majestically against the blue sea. Legends say Lord Shiva appeared here to rescue his devotee Supriya from a demon. The temple’s sanctum exudes divine calm, especially during Maha Shivaratri. Visitors can also explore the nearby Dwarkadhish Temple, Rukmini Temple, and Beyt Dwarka Island for a complete spiritual journey along Gujarat’s coast."
  },
  {
    "title": "Baijnath (Vaidyanath) Jyotirlinga – Jharkhand",
    "description": "Also known as Baba Dham, Vaidyanath Jyotirlinga is located in Deoghar, Jharkhand. Devotees believe Lord Shiva resides here as the divine healer or Vaidya. Pilgrims undertake the Kanwar Yatra, carrying holy Ganga water from Sultanganj to pour on the lingam. The temple complex has a serene ambiance and ancient charm. Mythology associates it with Ravana, who offered his heads to Lord Shiva in devotion. The spiritual energy, especially during Shravan month, fills the atmosphere with chants of ‘Bol Bam’ and unwavering faith."
  },
  {
    "title": "Rameshwaram Jyotirlinga – Tamil Nadu",
    "description": "Situated on Rameswaram Island, Rameshwaram Jyotirlinga is closely associated with Lord Rama’s journey to Lanka. The temple’s long corridors and carved pillars are architectural marvels. Pilgrims bathe in 22 holy wells before darshan, symbolizing purification. According to legend, Rama worshipped Shiva here to absolve his sins after the war with Ravana. The temple’s proximity to Dhanushkodi and the Pamban Bridge adds scenic beauty. It remains a sacred destination for both Shaivites and Vaishnavites, representing unity in India’s spiritual fabric."
  },
  {
    "title": "Grishneshwar Jyotirlinga – Maharashtra",
    "description": "Located near Ellora Caves in Aurangabad, Grishneshwar is the twelfth and final Jyotirlinga, symbolizing compassion and divine grace. The temple, built in red stone, showcases intricate carvings and a peaceful aura. It is said that a devoted woman named Kusuma worshipped here, leading to the divine manifestation of Shiva. The temple’s proximity to the UNESCO-listed Ellora Caves and Daulatabad Fort enhances its significance. Visitors experience both spiritual fulfillment and historical grandeur in this sacred region of Maharashtra."
  }
],

"services": [
    {
      "name": "Panch Jyotirlinga Tour from Pune",
      "description": "Embark on a divine Panch Jyotirlinga Tour from Pune with Meghana Cab and experience the spiritual essence of Maharashtra. This pilgrimage covers the five sacred Jyotirlingas—Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. Our tour ensures a comfortable and safe journey with professional drivers, air-conditioned vehicles, and well-planned itineraries. Whether you’re traveling solo, with family, or in a group, Meghana Cab offers customizable packages that combine devotion with comfort. Enjoy seamless pickup and drop services, clean vehicles, and flexible timing for your darshan schedule. Book your Panch Jyotirlinga trip from Pune today and let your spiritual journey begin with peace, faith, and hassle-free travel."
    },
    {
      "name": "Panch Jyotirlinga Darshan from Pune",
      "description": "Plan your Panch Jyotirlinga Darshan from Pune with Meghana Cab for a spiritually fulfilling experience across Maharashtra’s most revered Shiva temples. Our specially curated pilgrimage packages take you to Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath Jyotirlingas. We provide AC cabs, courteous drivers familiar with temple routes, and flexible schedules to accommodate your devotional itinerary. Ideal for families and devotees, our cabs are well-maintained to ensure a smooth, safe, and comfortable journey. Enjoy divine blessings while we handle the logistics. Book now for a sacred and memorable Panch Jyotirlinga darshan from Pune with Meghana Cab."
    },
    {
      "name": "Pune Jyotirlinga Darshan",
      "description": "Experience an unforgettable Pune Jyotirlinga Darshan tour with Meghana Cab. Visit Maharashtra’s iconic Jyotirlingas—Bhimashankar, Trimbakeshwar, and Grishneshwar—within a comfortable and flexible travel schedule. Our Pune-based taxi services provide reliable, air-conditioned cabs with experienced drivers who know temple routes and timings. Whether you want a single-day trip or a multi-day tour, we offer personalized packages suited to your budget and comfort. Travel with family or friends and enjoy a peaceful pilgrimage experience without the stress of planning routes or accommodations. Book your Pune Jyotirlinga Darshan with Meghana Cab today and explore the spiritual heart of Maharashtra."
    },
    {
      "name": "3 Jyotirlinga in Maharashtra Tour Package",
      "description": "Discover divine serenity with Meghana Cab’s 3 Jyotirlinga in Maharashtra tour package. Cover Bhimashankar, Trimbakeshwar, and Grishneshwar Jyotirlingas in a comfortable and well-planned itinerary. Our tour includes AC cab travel, professional chauffeurs, and flexible timings for darshan and rest stops. Perfect for weekend pilgrims or families seeking spiritual travel, this package combines devotion, comfort, and convenience. You can also customize your trip to include sightseeing nearby holy destinations. Book our 3 Jyotirlinga Maharashtra package today and experience a sacred journey filled with blessings, smooth travel, and unforgettable devotion."
    },
    {
      "name": "3 Jyotirlinga in Maharashtra Tour Package from Pune",
      "description": "Meghana Cab offers the best 3 Jyotirlinga tour package from Pune, covering Bhimashankar, Trimbakeshwar, and Grishneshwar. This carefully planned pilgrimage ensures you can complete darshan at all three temples comfortably and peacefully. Our professional drivers, air-conditioned cars, and flexible travel schedules make it easy to focus on the spiritual experience. Ideal for families, elderly travelers, and devotees, the tour includes pick-up and drop-off from your doorstep in Pune. We ensure safe driving, clean cars, and on-time temple visits. Book your 3 Jyotirlinga Maharashtra tour from Pune with Meghana Cab and experience a devotional retreat like never before."
    },
    {
      "name": "Maharashtra 5 Jyotirlinga Darshan",
      "description": "Seek divine blessings on your Maharashtra 5 Jyotirlinga Darshan with Meghana Cab. This pilgrimage includes visits to Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath Jyotirlingas. Our package offers reliable AC cab services, experienced drivers, and flexible travel options suited for individuals, families, and groups. We handle all travel logistics so you can focus on your spiritual journey. The tour combines devotion with comfort, allowing pilgrims to visit all five temples peacefully and safely. Book your 5 Jyotirlinga Darshan package with Meghana Cab from Pune today for a deeply fulfilling pilgrimage experience."
    },
    {
      "name": "Pune to Bhimashankar Cab",
      "description": "Book a comfortable Pune to Bhimashankar cab with Meghana Cab for a smooth drive through scenic ghats and lush landscapes. Ideal for devotees visiting the Bhimashankar Jyotirlinga temple, we provide AC cabs, courteous drivers, and door-to-door pickup and drop services. The journey promises safety, convenience, and peace as you travel through Maharashtra’s beautiful countryside. Whether for one-way travel, a round trip, or a full Panch Jyotirlinga pilgrimage, our Bhimashankar cab service from Pune ensures a divine and comfortable travel experience."
    },
    {
      "name": "Pune to Trimbakeshwar Cab",
      "description": "Travel conveniently from Pune to Trimbakeshwar with Meghana Cab’s reliable taxi service. Visit the sacred Trimbakeshwar Jyotirlinga temple in Nashik district in a clean, air-conditioned car driven by experienced professionals. Perfect for family pilgrimages, weekend trips, or inclusion in Jyotirlinga packages, our Pune to Trimbakeshwar cab ensures on-time arrival and complete comfort. Enjoy flexible travel schedules, safe driving, and peaceful travel to one of Maharashtra’s most divine destinations."
    },
    {
      "name": "Pune to Grishneshwar Jyotirlinga Cab",
      "description": "Embark on a spiritual trip from Pune to Grishneshwar Jyotirlinga near Ellora with Meghana Cab. Our cab service offers a hassle-free journey with AC vehicles, experienced chauffeurs, and flexible trip options. Visit the temple dedicated to Lord Shiva and explore the nearby Ellora Caves and Aurangabad attractions if desired. This service is ideal for solo travelers, families, and groups seeking comfortable long-distance travel. Book now for a smooth and spiritually enriching trip from Pune to Grishneshwar Jyotirlinga."
    },
    {
      "name": "Pune to Aundha Nagnath Cab Service",
      "description": "Book a Pune to Aundha Nagnath cab service with Meghana Cab for a safe and comfortable pilgrimage journey. The Aundha Nagnath temple, one of the 12 Jyotirlingas, holds immense spiritual importance. Our AC cars, courteous drivers, and on-time service make the long-distance trip easy and peaceful. Whether you’re on a solo darshan or a complete Panch Jyotirlinga tour, Meghana Cab ensures reliable service and a smooth journey across Maharashtra’s sacred sites."
    },
    {
      "name": "Pune to Parli Vaijnath Cab Service",
      "description": "Plan your Pune to Parli Vaijnath trip with Meghana Cab for a divine and convenient travel experience. Parli Vaijnath Jyotirlinga, located in Beed district, is a sacred destination for Shiva devotees. Our cabs are equipped with air conditioning and comfortable seating for long-distance travel. With courteous drivers, on-time pickup, and flexible tour options, you can combine your Parli visit with other Jyotirlingas or explore nearby temples. Book your Parli Vaijnath cab service from Pune today for a safe and blessed journey."
    },
    {
      "name": "Cheapest Jyotirlinga Darshan Cab Booking",
      "description": "Meghana Cab offers the cheapest Jyotirlinga darshan cab booking packages from Pune without compromising on comfort or quality. Our budget-friendly cab services cover popular Jyotirlinga temples across Maharashtra, including Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. Choose from hatchbacks, sedans, SUVs, and Innovas based on your group size. Enjoy devotional travel at affordable rates with professional drivers and safe, well-maintained vehicles. Book your economical Jyotirlinga tour cab now and experience devotion with convenience."
    },
    {
      "name": "Jyotirlinga Darshan Package from Pune",
      "description": "Discover the ultimate spiritual journey with Meghana Cab’s Jyotirlinga Darshan Package from Pune. This package is designed for devotees wishing to visit all major Jyotirlingas in Maharashtra comfortably and efficiently. We offer flexible itineraries, professional chauffeurs, AC cabs, and complete logistical support to make your pilgrimage effortless. Whether you’re planning a family trip or group tour, our customizable darshan packages include temple visits, sightseeing, and hotel coordination upon request. Book your Jyotirlinga Darshan Package from Pune and experience devotion with unmatched comfort and reliability."
    },
    {
      "name": "Jyotirlinga Darshan Tour Package",
      "description": "Explore Maharashtra’s sacred Jyotirlingas with Meghana Cab’s Jyotirlinga Darshan Tour Package. Cover all major temples like Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath in a single, well-planned itinerary. Our services include door-to-door pickup from Pune, AC cabs, polite drivers, and flexible scheduling. We ensure that your pilgrimage is not only spiritual but also relaxing and convenient. Choose between budget, standard, or premium vehicles to suit your needs. Book your Jyotirlinga Darshan Tour Package today and embark on a divine journey with peace and comfort."
    },
    {
      "name": "Innova Crysta for Jyotirlinga Darshan",
      "description": "Travel luxuriously on your Jyotirlinga pilgrimage with Meghana Cab’s Innova Crysta for Jyotirlinga Darshan service. Ideal for families and groups, our spacious Innovas provide exceptional comfort, smooth rides, and ample luggage space for long-distance travel. Visit all five Jyotirlingas—Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath—without any travel fatigue. Our drivers are experienced, polite, and well-versed with temple routes. Experience a peaceful and premium darshan journey with Meghana Cab’s Innova Crysta rentals from Pune."
    }
  ],

  "tableData": [
    ["Panch Jyotirlinga Tour from Pune", "Panch Jyotirlinga Darshan from Pune"],
    ["Pune Jyotirlinga Darshan", "3 Jyotirlinga in Maharashtra Tour Package"],
    ["3 Jyotirlinga in Maharashtra Tour Package from Pune", "Maharashtra 5 Jyotirlinga Darshan"],
    ["Pune to Bhimashankar Cab", "Pune to Trimbakeshwar Cab"],
    ["Pune to Grishneshwar Jyotirlinga Cab", "Pune to Aundha Nagnath Cab Service"],
    ["Pune to Parli Vaijnath Cab Service", "Cheapest Jyotirlinga Darshan Cab Booking"],
    ["Jyotirlinga Darshan Package from Pune", "Jyotirlinga Darshan Tour Package"],
    ["Innova Crysta for Jyotirlinga Darshan", ""],
    ["", ""]
  ],











"whychoose": [
    {
        "WhyChooseheading": "Spiritual Pune to Jyotirlinga Darshan Package",
        "WhyChoosedescription": "Meghana Cab offers specially curated cab packages for Jyotirlinga Darshan from Pune. Experience a peaceful and devotional journey to sacred temples like Trimbakeshwar, Bhimashankar, Grishneshwar, and more."
    },
    {
        "WhyChooseheading": "Comfortable Rides to Sacred Destinations",
        "WhyChoosedescription": "Travel in comfort with our well-maintained, air-conditioned vehicles as you visit prominent Jyotirlingas. Our cabs ensure a relaxed and spiritually fulfilling journey."
    },
    {
        "WhyChooseheading": "Knowledgeable Drivers for Pilgrimage Routes",
        "WhyChoosedescription": "Our drivers are familiar with major pilgrimage routes and temple timings, ensuring a smooth and timely darshan experience throughout your journey from Pune."
    },
    {
        "WhyChooseheading": "Affordable Jyotirlinga Tour Packages",
        "WhyChoosedescription": "Meghana Cab offers budget-friendly Jyotirlinga Darshan packages from Pune with clear pricing and no hidden charges—ideal for families and groups seeking spiritual tours."
    },
    {
        "WhyChooseheading": "Safe, Sanitized, and Devotee-Friendly Vehicles",
        "WhyChoosedescription": "All our cabs are regularly sanitized and equipped with safety features, offering a secure environment for senior citizens and devotees on religious journeys."
    },
    {
        "WhyChooseheading": "24/7 Pilgrimage Travel Support",
        "WhyChoosedescription": "We operate round the clock to match your temple visit schedules, whether it’s early morning aarti or evening darshan. Our team is always ready to assist your pilgrimage needs."
    },
    {
        "WhyChooseheading": "Customizable Pilgrimage Itineraries",
        "WhyChoosedescription": "Choose your own temples and travel plan with our customizable Jyotirlinga Darshan packages. Include stops at other spiritual spots as per your devotion and preferences."
    },
    {
        "WhyChooseheading": "Easy Booking for Darshan Tours",
        "WhyChoosedescription": "Book your Pune to Jyotirlinga Darshan cab easily through our website or app. Our support team is available to guide you through planning a seamless and divine trip."
    }
]



















    }

const faqData = [
    {
        question: "How can I book the Pune to Jyotirlinga Darshan Package with Meghana Cab?",
        answer: "You can book the Pune to Jyotirlinga Darshan Package through Meghana Cab’s website or by calling our customer service at +91 9075462128."
    },
    {
        question: "Which Jyotirlingas are covered in the Pune to Jyotirlinga Darshan Package?",
        answer: "The package typically includes darshan at popular Jyotirlingas like Trimbakeshwar, Bhimashankar, Grishneshwar, and Aundha Nagnath. Custom itineraries are also available on request."
    },
    {
        question: "What vehicle options are available for the Jyotirlinga Darshan trip from Pune?",
        answer: "We offer hatchbacks, sedans, SUVs, and tempo travellers based on group size and comfort requirements."
    },
    {
        question: "How many days does the Pune to Jyotirlinga Darshan Package take?",
        answer: "The duration depends on the number of Jyotirlingas covered, but typical packages range from 2 to 5 days."
    },
    {
        question: "Is food and accommodation included in the Jyotirlinga Darshan Package?",
        answer: "Accommodation can be included on request. Meals are usually not included but can be arranged at an additional cost."
    },
    {
        question: "Are tolls, parking, and taxes included in the Jyotirlinga Darshan cab fare?",
        answer: "Tolls, parking fees, and state taxes are additional and clearly informed during the booking process."
    },
    {
        question: "Can I customize the Jyotirlinga Darshan itinerary?",
        answer: "Yes, we offer customizable packages. You can choose the Jyotirlingas to visit, travel duration, and halts as per your preference."
    },
    {
        question: "Are Meghana Cab drivers familiar with the Jyotirlinga pilgrimage routes?",
        answer: "Yes, our drivers are experienced and knowledgeable about the pilgrimage routes, temples, and local areas."
    },
    {
        question: "Is the Pune to Jyotirlinga Darshan Package available for night travel?",
        answer: "Yes, based on your itinerary and preferences, night travel can be arranged safely and comfortably."
    },
    {
        question: "How do I get more information or book the Jyotirlinga Darshan Package?",
        answer: "For more details and bookings, contact Meghana Cab at +91 9075462128."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Suresh Jadhav',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“We booked the Jyotirlinga Darshan package from Pune with Meghana Cab. The entire journey was peaceful and well-organized. The driver knew all the temple timings and routes.”',
    },
    {
        name: 'Mrs. Anjali Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Our pilgrimage to Bhimashankar and Trimbakeshwar with Meghana Cab was very satisfying. Punctual service and very cooperative driver. Highly recommended for spiritual trips.”',
    },
];














































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Jyotirlinga Darshan Package",
  "description": "Explore the sacred Panch Jyotirlinga Darshan tour from Pune with Meghana Cabs. Comfortable and affordable cab services covering Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. Book your spiritual journey with us today!",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "4302"
  }
};






    return (
        <div>


<Helmet>
  <title>Pune to Jyotirlinga Darshan Package | Panch Jyotirlinga Tour from Pune @ Meghana Cabs</title>
  <meta
    name="description"
    content="Book the Pune to Jyotirlinga Darshan Package with Meghana Cabs. Affordable and reliable cab service for Panch Jyotirlinga tour from Pune including Bhimashankar, Trimbakeshwar, Grishneshwar, and more."
  />
  <meta
    name="keywords"
    content="Panch jyotirlinga tour from pune, Panch jyotirlinga darshan from pune, Pune jyotirlinga darshan, 3 jyotirlinga in maharashtra tour package, 3 jyotirlinga in maharashtra tour package from pune, maharashtra 5 jyotirlinga darshan, pune to bhimashankar cab, pune to trimbakeshwar cab, pune to grishneshwar jyotirlinga cab, pune to aundha nagnath cab service, pune to parli vaijnath cab service, cheapest jyotirlinga darshan cab booking, jyotirlinga darshan package from pune, jyotirlinga darshan tour package, innova crysta for jyotirlinga darshan"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/56.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetojyotilingadarshanpackage;